import { visibilityUtils } from "@juicetechnologyag/webapp-platform-api";
import React from "react";

function usePolling(callback: Function | undefined, defaultInterval: number) {
  const timerRef = React.useRef<NodeJS.Timeout>();
  const visibilityRef = React.useRef<boolean>(true);

  const intervalRef = React.useRef(defaultInterval);

  const start = React.useCallback(() => {
    if (typeof callback !== "function") return;

    timerRef.current = setTimeout(async function poll() {
      // check visibility before poll
      if (!visibilityRef.current) return;

      try {
        await callback();
      } catch (e) {
        console.error("Polling error", e);
      }

      timerRef.current = setTimeout(poll, intervalRef.current);
    }, intervalRef.current);
  }, [callback]);

  const stop = React.useCallback(() => {
    if (timerRef.current) clearTimeout(timerRef.current);
  }, []);

  const changeInterval = React.useCallback((interval: number) => {
    intervalRef.current = interval;
  }, []);

  React.useEffect(() => {
    const listener = (visibility: boolean) => {
      if (!visibility) return stop();
    };

    visibilityUtils.addEventListener(listener);
    return () => {
      visibilityUtils.removeEventListener(listener);
    };
  }, [stop]);

  const polling = React.useMemo(
    () => ({
      start,
      stop,
      changeInterval,
    }),
    [start, stop, changeInterval]
  );

  return polling;
}

export default usePolling;
